import { escapeForCSV } from '../../../core/utils/download.js';
import { parseDataToDate } from './parse-data-to-date.js';

export const sanitizeAndParseData = (value: unknown) => {
  const escapedValue = escapeForCSV(value);
  return parseDataToDate(escapedValue);
};
